import { createReducer, on } from "@ngrx/store";
import { initialApuCategoryState, apuCategoryAdapter } from "./apu-category.state"; 
import { ApuCategoryActions } from "./apu-category.actions";

export const apuCategoryReducer = createReducer(
    initialApuCategoryState,
    on(ApuCategoryActions.loadApuCategorySuccess, (state, action) => {
        return apuCategoryAdapter.setAll(action.apuCategories, {
            ...state,
            errorMessage: null
        });
    })
);